/** Switches the proposal card between "simple" (plain language) and
 * "advanced" (raw JSON-Patch, tool trace, validation errors). */
import { Code2, Sparkles } from 'lucide-react'
import { cn } from '@/lib/utils/cn'

export type AssistantMode = 'simple' | 'advanced'

interface Props {
  mode: AssistantMode
  onChange: (m: AssistantMode) => void
}

export function AssistantModeToggle({ mode, onChange }: Props) {
  return (
    <div
      role="tablist"
      aria-label="نمایش تغییرات"
      className="inline-flex items-center rounded-md border border-border bg-muted/40 p-0.5"
    >
      <ModeBtn active={mode === 'simple'} onClick={() => onChange('simple')} icon={<Sparkles className="w-3 h-3" />}>
        ساده
      </ModeBtn>
      <ModeBtn active={mode === 'advanced'} onClick={() => onChange('advanced')} icon={<Code2 className="w-3 h-3" />}>
        پیشرفته
      </ModeBtn>
    </div>
  )
}

function ModeBtn({
  active, onClick, icon, children,
}: { active: boolean; onClick: () => void; icon: React.ReactNode; children: React.ReactNode }) {
  return (
    <button
      role="tab"
      aria-selected={active}
      onClick={onClick}
      className={cn(
        'h-6 px-2 inline-flex items-center gap-1 text-[10px] rounded-sm transition-colors',
        active ? 'bg-background text-foreground shadow-sm' : 'text-muted-foreground hover:text-foreground',
      )}
    >
      {icon}{children}
    </button>
  )
}
